<div class="jumbotron">
    <h1 class="text-center">R&R Report</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="reports-content">
    <ngb-tabset
        activeId="w-tab-report-0"
        #tabSet="ngbTabset"
    >
        <ngb-tab id="w-tab-report-0">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="chart-box-outline"
                ></cmps-icon>
                Select Parameters
            </ng-template>
            <ng-template ngbTabContent>
                &nbsp;
                <div class="p-3">
                    <div
                        cmpsReportsRxRSelection
                        (generated)="onGeneratedReport($event)"
                        (changed)="onChanged()"
                        [params]="params"
                        [metrics]="availableMetrics"
                        [pendingData]="pendingData"
                        [rawDates]="rawDates"
                        [roles]="roles"
                    ></div>
                </div>
            </ng-template>
        </ngb-tab>
        <ngb-tab id="w-tab-report-1">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="file-document"
                ></cmps-icon>
                Report
            </ng-template>
            <ng-template ngbTabContent>
                <div
                    class="p-3"
                    *ngIf="pendingData"
                >
                    <cmps-wait-status></cmps-wait-status>
                    <h2 class="text-center">Report is being generated</h2>
                </div>

                <div
                    class="p-3"
                    *ngIf="!pendingData && params.noData"
                >
                    <h3 class="text-center">
                        There is no data generated for this report
                    </h3>
                </div>

                <div
                    class="p-3"
                    *ngIf="!pendingData && !params.noData"
                >
                    <div>
                        <button
                            class="btn-mini"
                            cmpsTooltipTrigger="Refresh"
                            (click)="getReportResult()"
                        >
                            <cmps-icon svgIcon="refresh"></cmps-icon>
                        </button>
                        <button
                            (click)="onExportClick()"
                            class="btn-mini"
                            cmpsTooltipTrigger="Export"
                        >
                            <cmps-icon svgIcon="download"></cmps-icon>
                        </button>
                    </div>

                    Name: <b class="f-s-75-2">{{ selectedUser?.userName }}</b>
                    <span class="soft-pipe">|</span>
                    Selected Role:
                    <b class="f-s-75-2">{{ selectedRole?.roleName }}</b>
                    <span class="soft-pipe">|</span>
                    Selected Date: <b class="f-s-75-2">{{ selectedDate }}</b>
                    <span class="soft-pipe">|</span>
                    Selected Date Range:
                    <b class="f-s-75-2">{{ startDate }} - {{ endDate }}</b>
                    <span class="soft-pipe">|</span>
                    Generated On:
                    <b class="f-s-75-2">{{ generatedDate }}</b>
                    <br />
                    <div class="m-12">
                        <p class="smallText">
                            <br />To edit the selected metrics click on the
                            "Select Parameters" tab
                        </p>
                    </div>
                    <div class="table-container mt-3 cmps-reports-table">
                        <table
                            #table
                            class="table"
                        >
                            <tr class="head">
                                <th
                                    class="title odd text-center vertical-center"
                                    rowspan="2"
                                >
                                    User Name
                                    <span (click)="toogleUserNameFilter()">
                                        <cmps-icon
                                            class="cmps-cdk-fill-grey-400"
                                            svgIcon="filter"
                                        ></cmps-icon>
                                    </span>
                                    <br />
                                    <span>
                                        <input
                                            *ngIf="usernameFilter"
                                            class="filterInput"
                                            #userName
                                            type="text"
                                            (input)="
                                                updateUserNameQuery(
                                                    userName.value
                                                )
                                            "
                                            [placeholder]=""
                                        />
                                    </span>
                                </th>
                                <th
                                    class="title odd text-center vertical-center"
                                    rowspan="2"
                                >
                                    Role
                                    <span (click)="toogleRoleFilter()">
                                        <cmps-icon
                                            class="cmps-cdk-fill-grey-400"
                                            svgIcon="filter"
                                        ></cmps-icon>
                                    </span>
                                    <br />
                                    <span>
                                        <input
                                            *ngIf="roleFilter"
                                            class="filterInput"
                                            #role
                                            type="text"
                                            (input)="
                                                updateRoleQuery(role.value)
                                            "
                                            [placeholder]=""
                                        />
                                    </span>
                                </th>
                                <th
                                    class="title odd text-center vertical-center"
                                    rowspan="2"
                                >
                                    SuperGroup
                                    <span (click)="toogleSuperGroupFilter()">
                                        <cmps-icon
                                            class="cmps-cdk-fill-grey-400"
                                            svgIcon="filter"
                                        ></cmps-icon>
                                    </span>
                                    <br />
                                    <span>
                                        <input
                                            *ngIf="supergroupFilter"
                                            class="filterInput"
                                            #superGroup
                                            type="text"
                                            (input)="
                                                updateSuperGroupQuery(
                                                    superGroup.value
                                                )
                                            "
                                            [placeholder]=""
                                        />
                                    </span>
                                </th>

                                <ng-template
                                    ngFor
                                    let-metric
                                    let-isOdd="odd"
                                    [ngForOf]="selectedMetrics"
                                >
                                    <th
                                        [class.even]="!isOdd"
                                        [class.odd]="isOdd"
                                        class="title text-center vertical-center"
                                        colspan="2"
                                    >
                                        {{ metric?.name }}
                                    </th>
                                </ng-template>
                            </tr>
                            <tr>
                                <ng-template
                                    ngFor
                                    let-metric
                                    [ngForOf]="selectedMetrics"
                                >
                                    <th
                                        class="title subeven text-center vertical-center"
                                    >
                                        Actual
                                    </th>
                                    <th
                                        class="title subeven text-center vertical-center"
                                    >
                                        Variance
                                    </th>
                                </ng-template>
                            </tr>
                            <tr *ngFor="let row of reportData">
                                <td>
                                    <cmps-icon
                                        class="cmps-cdk-fill-grey-300"
                                        svgIcon="account-circle"
                                    ></cmps-icon>
                                    {{ row.userName }}
                                </td>
                                <td class="text-center">{{ row.roleName }}</td>
                                <td class="text-center">
                                    {{ row.superGroupName }}
                                </td>

                                <ng-template
                                    ngFor
                                    let-metric
                                    [ngForOf]="row.metrics"
                                >
                                    <td
                                        class="text-center actualCol vertical-center"
                                        [class.highlightedCell]="
                                            metric.actual >= metric.target
                                        "
                                    >
                                        {{ metric.actual }}
                                    </td>
                                    <td
                                        class="text-center varianceCol vertical-center"
                                    >
                                        {{ metric.variance }}
                                    </td>
                                </ng-template>
                            </tr>
                        </table>
                    </div>
                </div>
            </ng-template>
        </ngb-tab>
    </ngb-tabset>
</div>
